import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function useCategoryMappingAuth() {
  const { getAccessTokenSilently } = useAuth0();
  return useCallback(async () => ({
    headers: {
      Authorization: "Bearer " + await getAccessTokenSilently(),
      "Content-Type": "application/json",
    },
  }), [getAccessTokenSilently]);
}
